import React, { Component, useEffect } from "react";
import { Row, Col, Button } from "reactstrap";
import { ProductType } from "../../../../../utils/Order/Order";
import Autosuggest from "../../../../Autosuggest/Autosuggest";
import styleF from "./../Field.module.scss";
import Options from "./Options/Options";
import Info from "./Info/Info";

class Symbol extends Component {
  constructor(props) {
    super(props);
    const { value, description, hideInfo } = props;

    const showInfo = !hideInfo && !!value;

    this.state = {
      showOptions: false,
      showInfo,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { form, description, value, assetid } = this.props;
    if (form != nextProps.form) {
      this.setState({ showInfo: false });
    }
    /// case de forex se necesita pedir assetInfo si estan las dos monedas selccionadas de la lista
    else if (form == ProductType.FOREX) {
      this.setState({ showInfo: nextProps.hideInfo != undefined && !nextProps.hideInfo });
    }

    if (nextProps.assetid && assetid !== nextProps.assetid && nextProps.assetInfo != undefined) {
      nextProps.assetInfo();
    }

    // if (nextProps.description && description !== nextProps.description && nextProps.assetInfo != undefined) {
    //   nextProps.assetInfo();
    // }
  }

  onSuggestionsFetchRequested = ({ value }) => {
    return this.props
      .searchSymbol({
        type: this.props.form,
        text: value,
      })
      .then((response) => response.response.symbols);
  };

  onChange = (method, value) => {
    const { attrId, attrTicker, attrDescription, attrProvider, hideInfo, attrCurrency } = this.props;

    let _value = defaultSymbolValue({
      attrId,
      attrTicker,
      attrDescription,
      attrProvider,
      attrCurrency,
    });

    if (method != "type") {
      _value = {
        [attrId]: value.Id,
        [attrTicker]: value.Ticker,
        [attrDescription]: value.Description,
        [attrProvider]: value.Provider,
        [attrCurrency]: value.SettCurrencyName,
      };
    } else {
      _value[attrTicker] = value;
    }

    this.props.onChange(_value, value);

    this.setState({ ...this.state, showInfo: method != "type" && !hideInfo });
  };

  toggleOptions = () => {
    if (!this.state.showOptions) {
      this.optionsMethod();
    }

    this.setState({ showOptions: !this.state.showOptions });
  };

  componentDidUpdate() {
    const { updatePrice } = this.props;
    updatePrice ? updatePrice() : null;
  }

  handleLoadAssetOrderData = (orderAssetData) => {
    this.props.onChange({ OrderAssetData: orderAssetData });
  };

  render() {
    const {
      form,
      placeholder,
      invalid,
      disabled,
      value,
      value2,
      description,
      provider,
      getYahooOptions,
      assetInfo,
      hideButtonOptn,
    } = this.props;

    const { showOptions, showInfo } = this.state;
    const inputProps = {
      placeholder,
      invalid,
      disabled,
    };

    return (
      <React.Fragment>
        <Row>
          <Col lg={form == ProductType.OPTION && !hideButtonOptn ? 6 : 12}>
            <Autosuggest
              onChange={this.onChange}
              renderSuggestion={renderSuggestion}
              getSuggestionValue={getSuggestionValue}
              onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
              inputProps={inputProps}
              value={value || ""}
            />
          </Col>
          {form == ProductType.OPTION && !hideButtonOptn && (
            <GetOptions
              toggle={this.toggleOptions}
              open={showOptions}
              symbol={value}
              fetchOptions={getYahooOptions}
              setValues={(method) => (this.optionsMethod = method)}
              onChange={this.props.onChange}
              disabled={disabled}
            />
          )}
        </Row>

        {showInfo && value != "" ? (
          <Info
            form={form}
            value={value}
            value2={value2}
            description={description}
            provider={provider}
            assetInfo={assetInfo}
            onLoadAssetOrderData={this.handleLoadAssetOrderData}
          />
        ) : null}
      </React.Fragment>
    );
  }
}

const defaultSymbolValue = ({ attrTicker, attrId, attrDescription, attrProvider, attrCurrency }) => ({
  [attrId]: null,
  [attrTicker]: "",
  [attrDescription]: null,
  [attrProvider]: null,
  [attrCurrency]: null,
});

const renderSuggestion = (suggestion) => {
  return (
    <div className={styleF.suggestionItem}>
      {suggestion.Ticker}
      {" - "}
      <span>{suggestion.Description}</span>
    </div>
  );
};

const getSuggestionValue = (suggestion) => suggestion.Ticker;

const GetOptions = ({ symbol, toggle, open, setValues, fetchOptions, onChange, disabled }) => (
  <Col lg={6}>
    <Button style={{ width: "100%" }} onClick={toggle} color={"primary"} disabled={!symbol || disabled}>
      Get Options
    </Button>
    {symbol && (
      <Options
        open={open}
        toggle={toggle}
        symbol={symbol}
        setValues={setValues}
        fetchOptions={fetchOptions}
        onChange={onChange}
      />
    )}
  </Col>
);

export default Symbol;
